export const faqItems = [
  {
    question: '红桃影院需要注册才能观看吗？',
    answer: '红桃影院支持免注册观看，您可以直接访问网站选择喜欢的电影或电视剧，点击播放即可享受高清流畅的观影体验。注册账号后还可以收藏影片、订阅更新通知等。',
  },
  {
    question: '红桃影院的影视资源是否免费？',
    answer: '是的，红桃影院所有内容均免费提供观看。我们致力于为用户打造无广告、零费用的优质观影平台，无需支付任何费用即可畅享海量影视资源。',
  },
  {
    question: '红桃影院支持哪些设备观看？',
    answer: '红桃影院完美适配电脑、平板、手机等多种设备，无论您使用Windows、Mac、iOS还是Android系统，均可通过浏览器流畅观看。支持投屏功能，可将内容投射到电视大屏上。',
  },
  {
    question: '影片画质如何？支持高清播放吗？',
    answer: '红桃影院提供720P、1080P高清画质，部分热门影片支持4K超清播放。系统会根据您的网络状况智能调整清晰度，确保流畅不卡顿的观影体验。',
  },
  {
    question: '如何搜索我想看的影片？',
    answer: '您可以在首页顶部的搜索框中输入影片名称、演员名字或导演姓名，系统会快速匹配并展示相关结果。也可以通过分类页面按类型、地区、年代等条件筛选影片。',
  },
  {
    question: '红桃影院的资源多久更新一次？',
    answer: '我们的内容团队每日更新影视资源，热门电影、最新剧集上线后24小时内即可在红桃影院观看。综艺节目通常在播出当天同步更新，确保您不错过任何精彩内容。',
  },
  {
    question: '观看时会弹出广告吗？',
    answer: '红桃影院承诺全程无广告打扰。我们致力于提供纯净的观影环境，您不会在播放前、播放中或播放后遇到任何广告弹窗，享受沉浸式观影体验。',
  },
  {
    question: '如果遇到播放问题该如何处理？',
    answer: '如遇播放卡顿，建议尝试切换播放线路（影片播放器提供多条线路可选），或降低画质以获得更流畅的体验。若问题持续存在，可通过关于我们页面的联系表单反馈，技术团队会尽快处理。',
  },
];

export const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};